var _defs, _ellipse, _ellipse2, _ellipse3, _g, _path, _text, _text2, _rect, _g2, _rect2, _path2, _path3, _g3, _ellipse4, _text3, _text4, _text5, _text6, _g4, _g5, _text7, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnterpriseScope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 460",
    width: 1000,
    height: 460,
    role: "img",
    "aria-label": "BossDrop for Enterprise: four team pods, each with its own BossDrop AI layer, rolling up into a single org-level executive view, with SSO, advanced permissions, cross-team reporting and priority support. Many teams, cross-team rollups, enterprise controls.",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "esAmbient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    fx: 0.36,
    fy: 0.3
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a6ab8",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#63569c",
    stopOpacity: 0.225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#4c4380",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#443c73",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#3e3668",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e3668",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "esHalo",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    fx: 0.44,
    fy: 0.34
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7a4e6",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#b7a4e6",
    stopOpacity: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#8f7fd0",
    stopOpacity: 0.066
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#8f7fd0",
    stopOpacity: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f7fd0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "esKey",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    fx: 0.32,
    fy: 0.36
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efe9fa",
    stopOpacity: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#cfc3ee",
    stopOpacity: 0.042
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#cfc3ee",
    stopOpacity: 0.008
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfc3ee",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "esFloorFade",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    fx: 0.42,
    fy: 0.34
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fff",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#fff",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "esFloorPlane",
    x1: 0.08,
    y1: 0,
    x2: 0.68,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efe9fa",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#b7a4e6",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7e70c0",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#3a3160",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#211b3d",
    stopOpacity: 0.18
  })), /*#__PURE__*/React.createElement("mask", {
    id: "esFloorMask"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 500,
    cy: 366,
    rx: 472,
    ry: 92,
    fill: "url(#esFloorFade)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "esRim",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfc3ee",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#e6ddfa",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#cfc3ee",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9d8fd6",
    stopOpacity: 0.065
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d8fd6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "esContact",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    fx: 0.44,
    fy: 0.44
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07050f",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#07050f",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#07050f",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07050f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "esFunnel",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    fx: 0.46,
    fy: 0.34
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff7cb",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#f0dfb0",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#cfc3ee",
    stopOpacity: 0.055
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#cfc3ee",
    stopOpacity: 0.012
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfc3ee",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "esExecFace",
    x1: 0.06,
    y1: 0,
    x2: 0.56,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2c2743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b182b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "esExecEdge",
    x1: 0.04,
    y1: 0,
    x2: 0.82,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff7cb",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f0d99a",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#b79a5e",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a6a4a",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "esCreamHi",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffdf0",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fff7cb",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff7cb",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "esPodFace",
    x1: 0.08,
    y1: 0,
    x2: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#514873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#2f2a4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c1930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "esPodEdge",
    x1: 0.08,
    y1: 0,
    x2: 0.62,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9587d8",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#5a5090",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a2547",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "esSceneLight",
    gradientUnits: "userSpaceOnUse",
    x1: 40,
    y1: 210,
    x2: 960,
    y2: 420
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efe9fa",
    stopOpacity: 0.115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#cfc3ee",
    stopOpacity: 0.045
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#1a1430",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100e1d",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "esSceneLightPill",
    gradientUnits: "userSpaceOnUse",
    x1: 40,
    y1: 210,
    x2: 960,
    y2: 420
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efe9fa",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#cfc3ee",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#1a1430",
    stopOpacity: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100e1d",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "esChipFace",
    x1: 0.1,
    y1: 0,
    x2: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#474070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2e294c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201c38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "esChipEdge",
    x1: 0.1,
    y1: 0,
    x2: 0.6,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8477c9",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4c4380",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a2547",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "esai",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fd8f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b7a4e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f7fd0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "esaiShade",
    x1: 0.12,
    y1: 0,
    x2: 0.34,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ffffff",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#1a1430",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1430",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "esTopHi",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffffff",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "esTopHiSoft",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6ddfa",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#e6ddfa",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6ddfa",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "esgold",
    cx: 0.34,
    cy: 0.28,
    r: 0.82
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffdf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fff2bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#e9c46a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c39a3c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "esNodeFace",
    cx: 0.33,
    cy: 0.26,
    r: 0.85
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b61a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#3e3768"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1a33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "esNodeEdge",
    x1: 0.15,
    y1: 0,
    x2: 0.7,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a294e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#665a9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3360"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "esFlow",
    gradientUnits: "userSpaceOnUse",
    x1: 500,
    y1: 231,
    x2: 500,
    y2: 164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8878c8",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a795dd",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#cdbfec",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eae1f8",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "esFlowM",
    gradientUnits: "userSpaceOnUse",
    x1: 500,
    y1: 245,
    x2: 500,
    y2: 186
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8878c8",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a795dd",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#cdbfec",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eae1f8",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "esArrowFace",
    x1: 0.92,
    y1: 0,
    x2: 0.1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6f1fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#cdbfec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f6fbd"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "esarrow",
    viewBox: "0 0 10 10",
    refX: 10,
    refY: 5,
    markerWidth: 3.6,
    markerHeight: 3.6,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.6 L10 5 L0 9.4 z",
    fill: "url(#esArrowFace)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "esLiftXL",
    x: "-25%",
    y: "-250%",
    width: "150%",
    height: "600%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 1,
    dy: 2,
    stdDeviation: 2,
    floodColor: "#08061a",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 6,
    dy: 14,
    stdDeviation: 12,
    floodColor: "#08061a",
    floodOpacity: 0.44
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 14,
    dy: 32,
    stdDeviation: 30,
    floodColor: "#08061a",
    floodOpacity: 0.32
  })), /*#__PURE__*/React.createElement("filter", {
    id: "esLiftXLm",
    x: "-20%",
    y: "-150%",
    width: "140%",
    height: "400%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 1,
    dy: 2,
    stdDeviation: 2,
    floodColor: "#08061a",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 4,
    dy: 10,
    stdDeviation: 7,
    floodColor: "#08061a",
    floodOpacity: 0.44
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 7,
    dy: 18,
    stdDeviation: 12,
    floodColor: "#08061a",
    floodOpacity: 0.32
  })), /*#__PURE__*/React.createElement("filter", {
    id: "esLiftM",
    x: "-70%",
    y: "-250%",
    width: "240%",
    height: "600%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 1,
    dy: 2,
    stdDeviation: 1.6,
    floodColor: "#08061a",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 4,
    dy: 9,
    stdDeviation: 7,
    floodColor: "#08061a",
    floodOpacity: 0.42
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 6,
    dy: 14,
    stdDeviation: 9,
    floodColor: "#08061a",
    floodOpacity: 0.3
  })), /*#__PURE__*/React.createElement("filter", {
    id: "esLiftS",
    x: "-40%",
    y: "-160%",
    width: "180%",
    height: "420%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 1,
    dy: 2,
    stdDeviation: 1.4,
    floodColor: "#08061a",
    floodOpacity: 0.55
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 3,
    dy: 7,
    stdDeviation: 6,
    floodColor: "#08061a",
    floodOpacity: 0.4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "esTextSh",
    x: "-10%",
    y: "-60%",
    width: "130%",
    height: "260%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 1.5,
    stdDeviation: 2.6,
    floodColor: "#0b0918",
    floodOpacity: 0.66
  })), /*#__PURE__*/React.createElement("filter", {
    id: "esGlow",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 4,
    floodColor: "#b7a4e6",
    floodOpacity: 0.4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "esBeam",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  })), /*#__PURE__*/React.createElement("filter", {
    id: "esRimBlur",
    x: "-20%",
    y: "-400%",
    width: "140%",
    height: "900%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  })), /*#__PURE__*/React.createElement("filter", {
    id: "esBloom",
    x: "-30%",
    y: "-120%",
    width: "160%",
    height: "340%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  })), /*#__PURE__*/React.createElement("style", null, "\n      .est  { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:800; fill:#f4f0fc; }\n      .ess  { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:600; fill:#bcb4d2; }\n      .eseye{ font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#cfc3ee; letter-spacing:4px; }\n      .espill{ font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:800; fill:#121020; }\n      .eslab{ font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#e2d9f5; }\n      .eschip{ font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#e7dff7; }\n      .esexec{ font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:800; fill:#f7dd9a; }\n      .essub{ font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:500; fill:#b3abc8; }\n      /* This label names the idea of the drawing and it stands on the brightest\n         value in the scene, so it is the one run that has to be near-white:\n         #f0ebfb on the measured pool background clears WCAG AA with margin. */\n      .esroll{ font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:600; fill:#f0ebfb; }\n      .mOnly { display:none; }\n\n      /* Phone. An image-referenced SVG evaluates media queries against its own\n         rendered width, so this fires only at the ~343px the page gives it on a\n         handset, where the desktop 12px type would land at 4px. Type grows to\n         what the artboard can hold and the surfaces grow with it. Geometry\n         only: every label stays horizontal and every word stays the same. */\n      @media (max-width: 560px) {\n        .dOnly { display:none; }\n        .mOnly { display:inline; }\n\n        .eseye  { font-size:24px; letter-spacing:5px; transform:translateY(-16px); }\n        .est    { font-size:34px; transform:translateY(-18px); }\n        .esexec { font-size:32px; }\n        .essub  { font-size:28px; }\n        .esroll { font-size:23px; transform:translateY(19px); }\n        .espill { font-size:23px; transform:translateY(2px); }\n        .eslab  { font-size:28px; transform:translateY(5px); }\n        .eschip { font-size:24px; }\n        .ess    { font-size:25px; transform:translateY(-7px); }\n\n        /* Org-level card: wide, but never closer to an artboard edge than its\n           own shadow can reach. 64 units of clearance each side against the\n           43-unit reach of esLiftXLm, and the bloom is inset a further 40 so\n           its 48-unit blur also lands inside the viewBox. */\n        .esexeccard  { x:64px;  y:76px; width:872px; height:110px; rx:20px; }\n        .esbloom     { x:104px; y:82px; width:792px; height:110px; rx:20px; }\n        .execlift    { filter:url(#esLiftXLm); }\n        .esexecav    { transform:translate(108px,131px) scale(1.5); transform-origin:0 0; }\n        .esexectitle { transform:translate(-143px,-8px); }\n        .esfunnel    { cy:200px; rx:175px; ry:30px; }\n\n        /* the pods, chips and summary drop together so the rollup band has\n           room to read and the label that names it can stay on the centre\n           line, under the convergence, instead of being shoved sideways */\n        .eslower { transform:translateY(14px); }\n\n        /* the pods lose the slack the bigger type does not need, which is what\n           buys the rollup band its room and keeps the chip row off the summary */\n        .espod   { height:116px; }\n        .espodsh { cy:351px; }\n\n        /* the four member rows grow around each pod's own centre */\n        .esav1 { transform:translate(-47.2px,-104.32px) scale(1.32); transform-origin:0 0; }\n        .esav2 { transform:translate(-122.4px,-104.32px) scale(1.32); transform-origin:0 0; }\n        .esav3 { transform:translate(-197.6px,-104.32px) scale(1.32); transform-origin:0 0; }\n        .esav4 { transform:translate(-272.8px,-104.32px) scale(1.32); transform-origin:0 0; }\n\n        /* control chips grow and re-pack to fill the row */\n        .eschipbox { y:366px; height:32px; rx:16px; }\n        .eschipbox.c1 { x:30px;  width:80px; }\n        .eschipbox.c2 { x:124px; width:290px; }\n        .eschipbox.c3 { x:428px; width:290px; }\n        .eschipbox.c4 { x:732px; width:238px; }\n        .eschipsh { cy:404px; }\n        .eschipsh.c1 { cx:70px;  rx:48px; }\n        .eschipsh.c2 { cx:269px; rx:153px; }\n        .eschipsh.c3 { cx:573px; rx:153px; }\n        .eschipsh.c4 { cx:851px; rx:127px; }\n        .eschiptx { transform:translateY(-4px); }\n        .eschiptx.c1 { transform:translate(-141px,-4px); }\n        .eschiptx.c2 { transform:translate(-88px,-4px); }\n        .eschiptx.c3 { transform:translate(10px,-4px); }\n        .eschiptx.c4 { transform:translate(102px,-4px); }\n      }\n    "))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 500,
    cy: 230,
    rx: 496,
    ry: 226,
    fill: "url(#esAmbient)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 496,
    cy: 206,
    rx: 390,
    ry: 164,
    fill: "url(#esHalo)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 452,
    cy: 196,
    rx: 440,
    ry: 190,
    fill: "url(#esKey)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#esFloorMask)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 276,
    width: 940,
    height: 182,
    fill: "url(#esFloorPlane)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 404 A400 34 0 0 1 896 404",
    fill: "none",
    stroke: "url(#esRim)",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    filter: "url(#esRimBlur)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 42,
    className: "eseye",
    fontSize: 15,
    filter: "url(#esTextSh)"
  }, "ENTERPRISE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 76,
    className: "est",
    fontSize: 26,
    filter: "url(#esTextSh)"
  }, "Many pods. One org-level view.")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "esbloom",
    x: 180,
    y: 98,
    width: 640,
    height: 72,
    rx: 16,
    fill: "#fff2c4",
    opacity: 0.15,
    filter: "url(#esBloom)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "execlift",
    filter: "url(#esLiftXL)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "esexeccard",
    x: 180,
    y: 92,
    width: 640,
    height: 72,
    rx: 16,
    fill: "url(#esExecFace)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "esexeccard",
    x: 180,
    y: 92,
    width: 640,
    height: 72,
    rx: 16,
    fill: "none",
    stroke: "url(#esExecEdge)",
    strokeWidth: 1.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "dOnly",
    d: "M180.9 108 A15.1 15.1 0 0 1 196 92.9 L804 92.9 A15.1 15.1 0 0 1 819.1 108",
    fill: "none",
    stroke: "url(#esCreamHi)",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "mOnly",
    d: "M64.9 96 A19.1 19.1 0 0 1 84 76.9 L916 76.9 A19.1 19.1 0 0 1 935.1 96",
    fill: "none",
    stroke: "url(#esCreamHi)",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "esexecav",
    transform: "translate(261,128)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 17,
    fill: "url(#esgold)"
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -5,
    r: 5.5,
    fill: "#2a1f08",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.5 10 a8.5 6.5 0 0 1 17 0 z",
    fill: "#2a1f08",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.5 -8.8 A17 17 0 0 1 14.5 -8.8",
    fill: "none",
    stroke: "url(#esTopHi)",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "esfunnel",
    cx: 500,
    cy: 188,
    rx: 200,
    ry: 46,
    fill: "url(#esFunnel)"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "esexec esexectitle",
    x: 293,
    y: 124,
    fontSize: 18,
    filter: "url(#esTextSh)"
  }, "Org-level executive view")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "essub dOnly",
    x: 293,
    y: 146,
    fontSize: 12.5
  }, "One brief across every team \xB7 owners, risks, decisions \xB7 no dashboards to maintain")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "essub mOnly",
    x: 150,
    y: 146,
    fontSize: 28
  }, "One brief across every team \xB7 owners, risks, decisions \xB7")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "essub mOnly",
    x: 150,
    y: 174,
    fontSize: 28
  }, "no dashboards to maintain")), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "dOnly",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "url(#esFlow)",
    strokeWidth: 9,
    opacity: 0.2,
    filter: "url(#esBeam)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.5 231 L 147.5 214 C 147.5 184, 458 202, 458 182 L 458 164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.5 231 L 382.5 214 C 382.5 194, 486 198, 486 182 L 486 164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.5 231 L 617.5 214 C 617.5 194, 514 198, 514 182 L 514 164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.5 231 L 852.5 214 C 852.5 184, 542 202, 542 182 L 542 164"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "url(#esFlow)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.88,
    filter: "url(#esGlow)",
    markerEnd: "url(#esarrow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.5 231 L 147.5 214 C 147.5 184, 458 202, 458 182 L 458 164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.5 231 L 382.5 214 C 382.5 194, 486 198, 486 182 L 486 164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.5 231 L 617.5 214 C 617.5 194, 514 198, 514 182 L 514 164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.5 231 L 852.5 214 C 852.5 184, 542 202, 542 182 L 542 164"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "mOnly",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "url(#esFlowM)",
    strokeWidth: 9,
    opacity: 0.2,
    filter: "url(#esBeam)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.5 245 L 147.5 220 C 147.5 200, 458 216, 458 204 L 458 186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.5 245 L 382.5 220 C 382.5 204, 486 214, 486 204 L 486 186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.5 245 L 617.5 220 C 617.5 204, 514 214, 514 204 L 514 186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.5 245 L 852.5 220 C 852.5 200, 542 216, 542 204 L 542 186"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "url(#esFlowM)",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.88,
    filter: "url(#esGlow)",
    markerEnd: "url(#esarrow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.5 245 L 147.5 220 C 147.5 200, 458 216, 458 204 L 458 186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.5 245 L 382.5 220 C 382.5 204, 486 214, 486 204 L 486 186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.5 245 L 617.5 220 C 617.5 204, 514 214, 514 204 L 514 186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.5 245 L 852.5 220 C 852.5 200, 542 216, 542 204 L 542 186"
  })))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 221,
    textAnchor: "middle",
    className: "esroll",
    fontSize: 13.5,
    filter: "url(#esTextSh)"
  }, "cross-team rollup")), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "eslower"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "espodsh",
    cx: 149,
    cy: 361,
    rx: 108,
    ry: 14,
    fill: "url(#esContact)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "espodsh",
    cx: 384,
    cy: 361,
    rx: 108,
    ry: 14,
    fill: "url(#esContact)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "espodsh",
    cx: 619,
    cy: 361,
    rx: 108,
    ry: 14,
    fill: "url(#esContact)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "espodsh",
    cx: 854,
    cy: 361,
    rx: 108,
    ry: 14,
    fill: "url(#esContact)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#esLiftM)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 232,
    className: "espod",
    width: 215,
    height: 126,
    rx: 14,
    fill: "url(#esPodFace)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 232,
    className: "espod",
    width: 215,
    height: 126,
    rx: 14,
    fill: "url(#esPodFace)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 232,
    className: "espod",
    width: 215,
    height: 126,
    rx: 14,
    fill: "url(#esPodFace)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 745,
    y: 232,
    className: "espod",
    width: 215,
    height: 126,
    rx: 14,
    fill: "url(#esPodFace)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "url(#esSceneLight)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 232,
    className: "espod",
    width: 215,
    height: 126,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 232,
    className: "espod",
    width: 215,
    height: 126,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 232,
    className: "espod",
    width: 215,
    height: 126,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 745,
    y: 232,
    className: "espod",
    width: 215,
    height: 126,
    rx: 14
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "url(#esPodEdge)",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 232,
    className: "espod",
    width: 215,
    height: 126,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 232,
    className: "espod",
    width: 215,
    height: 126,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 232,
    className: "espod",
    width: 215,
    height: 126,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 745,
    y: 232,
    className: "espod",
    width: 215,
    height: 126,
    rx: 14
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "url(#esTopHiSoft)",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9 246 A13.1 13.1 0 0 1 54 232.9 L241 232.9 A13.1 13.1 0 0 1 254.1 246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.9 246 A13.1 13.1 0 0 1 289 232.9 L476 232.9 A13.1 13.1 0 0 1 489.1 246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.9 246 A13.1 13.1 0 0 1 524 232.9 L711 232.9 A13.1 13.1 0 0 1 724.1 246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.9 246 A13.1 13.1 0 0 1 759 232.9 L946 232.9 A13.1 13.1 0 0 1 959.1 246"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#esLiftS)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#esai)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 244,
    width: 183,
    height: 28,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291,
    y: 244,
    width: 183,
    height: 28,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 244,
    width: 183,
    height: 28,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 761,
    y: 244,
    width: 183,
    height: 28,
    rx: 14
  })), /*#__PURE__*/React.createElement("g", {
    fill: "url(#esaiShade)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 244,
    width: 183,
    height: 28,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291,
    y: 244,
    width: 183,
    height: 28,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 244,
    width: 183,
    height: 28,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 761,
    y: 244,
    width: 183,
    height: 28,
    rx: 14
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "url(#esSceneLightPill)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 244,
    width: 183,
    height: 28,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291,
    y: 244,
    width: 183,
    height: 28,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 244,
    width: 183,
    height: 28,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 761,
    y: 244,
    width: 183,
    height: 28,
    rx: 14
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "url(#esTopHi)",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.9 258 A13.1 13.1 0 0 1 70 244.9 L225 244.9 A13.1 13.1 0 0 1 238.1 258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.9 258 A13.1 13.1 0 0 1 305 244.9 L460 244.9 A13.1 13.1 0 0 1 473.1 258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.9 258 A13.1 13.1 0 0 1 540 244.9 L695 244.9 A13.1 13.1 0 0 1 708.1 258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.9 258 A13.1 13.1 0 0 1 775 244.9 L930 244.9 A13.1 13.1 0 0 1 943.1 258"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: 147.5,
    y: 263,
    textAnchor: "middle",
    className: "espill",
    fontSize: 13
  }, "BossDrop AI"), /*#__PURE__*/React.createElement("text", {
    x: 382.5,
    y: 263,
    textAnchor: "middle",
    className: "espill",
    fontSize: 13
  }, "BossDrop AI"), /*#__PURE__*/React.createElement("text", {
    x: 617.5,
    y: 263,
    textAnchor: "middle",
    className: "espill",
    fontSize: 13
  }, "BossDrop AI"), /*#__PURE__*/React.createElement("text", {
    x: 852.5,
    y: 263,
    textAnchor: "middle",
    className: "espill",
    fontSize: 13
  }, "BossDrop AI")), /*#__PURE__*/React.createElement("g", {
    filter: "url(#esTextSh)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 147.5,
    y: 294,
    textAnchor: "middle",
    className: "eslab",
    fontSize: 14
  }, "Product"), /*#__PURE__*/React.createElement("text", {
    x: 382.5,
    y: 294,
    textAnchor: "middle",
    className: "eslab",
    fontSize: 14
  }, "Engineering"), /*#__PURE__*/React.createElement("text", {
    x: 617.5,
    y: 294,
    textAnchor: "middle",
    className: "eslab",
    fontSize: 14
  }, "Revenue"), /*#__PURE__*/React.createElement("text", {
    x: 852.5,
    y: 294,
    textAnchor: "middle",
    className: "eslab",
    fontSize: 14
  }, "Operations")), /*#__PURE__*/React.createElement("g", {
    className: "esav1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(95,326)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 11,
    fill: "url(#esNodeFace)",
    stroke: "url(#esNodeEdge)",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -3.5,
    r: 3.4,
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 9 a7.5 6 0 0 1 15 0 z",
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.4 -5.7 A11 11 0 0 1 9.4 -5.7",
    fill: "none",
    stroke: "url(#esTopHiSoft)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(129,326)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 11,
    fill: "url(#esNodeFace)",
    stroke: "url(#esNodeEdge)",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -3.5,
    r: 3.4,
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 9 a7.5 6 0 0 1 15 0 z",
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.4 -5.7 A11 11 0 0 1 9.4 -5.7",
    fill: "none",
    stroke: "url(#esTopHiSoft)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(163,326)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 11,
    fill: "url(#esNodeFace)",
    stroke: "url(#esNodeEdge)",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -3.5,
    r: 3.4,
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 9 a7.5 6 0 0 1 15 0 z",
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.4 -5.7 A11 11 0 0 1 9.4 -5.7",
    fill: "none",
    stroke: "url(#esTopHiSoft)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(197,326)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 11,
    fill: "url(#esNodeFace)",
    stroke: "url(#esNodeEdge)",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -3.5,
    r: 3.4,
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 9 a7.5 6 0 0 1 15 0 z",
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.4 -5.7 A11 11 0 0 1 9.4 -5.7",
    fill: "none",
    stroke: "url(#esTopHiSoft)",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    className: "esav2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(330,326)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 11,
    fill: "url(#esNodeFace)",
    stroke: "url(#esNodeEdge)",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -3.5,
    r: 3.4,
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 9 a7.5 6 0 0 1 15 0 z",
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.4 -5.7 A11 11 0 0 1 9.4 -5.7",
    fill: "none",
    stroke: "url(#esTopHiSoft)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(364,326)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 11,
    fill: "url(#esNodeFace)",
    stroke: "url(#esNodeEdge)",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -3.5,
    r: 3.4,
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 9 a7.5 6 0 0 1 15 0 z",
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.4 -5.7 A11 11 0 0 1 9.4 -5.7",
    fill: "none",
    stroke: "url(#esTopHiSoft)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(398,326)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 11,
    fill: "url(#esNodeFace)",
    stroke: "url(#esNodeEdge)",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -3.5,
    r: 3.4,
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 9 a7.5 6 0 0 1 15 0 z",
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.4 -5.7 A11 11 0 0 1 9.4 -5.7",
    fill: "none",
    stroke: "url(#esTopHiSoft)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,326)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 11,
    fill: "url(#esNodeFace)",
    stroke: "url(#esNodeEdge)",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -3.5,
    r: 3.4,
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 9 a7.5 6 0 0 1 15 0 z",
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.4 -5.7 A11 11 0 0 1 9.4 -5.7",
    fill: "none",
    stroke: "url(#esTopHiSoft)",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    className: "esav3"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(565,326)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 11,
    fill: "url(#esNodeFace)",
    stroke: "url(#esNodeEdge)",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -3.5,
    r: 3.4,
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 9 a7.5 6 0 0 1 15 0 z",
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.4 -5.7 A11 11 0 0 1 9.4 -5.7",
    fill: "none",
    stroke: "url(#esTopHiSoft)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(599,326)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 11,
    fill: "url(#esNodeFace)",
    stroke: "url(#esNodeEdge)",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -3.5,
    r: 3.4,
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 9 a7.5 6 0 0 1 15 0 z",
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.4 -5.7 A11 11 0 0 1 9.4 -5.7",
    fill: "none",
    stroke: "url(#esTopHiSoft)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(633,326)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 11,
    fill: "url(#esNodeFace)",
    stroke: "url(#esNodeEdge)",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -3.5,
    r: 3.4,
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 9 a7.5 6 0 0 1 15 0 z",
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.4 -5.7 A11 11 0 0 1 9.4 -5.7",
    fill: "none",
    stroke: "url(#esTopHiSoft)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(667,326)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 11,
    fill: "url(#esNodeFace)",
    stroke: "url(#esNodeEdge)",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -3.5,
    r: 3.4,
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 9 a7.5 6 0 0 1 15 0 z",
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.4 -5.7 A11 11 0 0 1 9.4 -5.7",
    fill: "none",
    stroke: "url(#esTopHiSoft)",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    className: "esav4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(800,326)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 11,
    fill: "url(#esNodeFace)",
    stroke: "url(#esNodeEdge)",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -3.5,
    r: 3.4,
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 9 a7.5 6 0 0 1 15 0 z",
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.4 -5.7 A11 11 0 0 1 9.4 -5.7",
    fill: "none",
    stroke: "url(#esTopHiSoft)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(834,326)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 11,
    fill: "url(#esNodeFace)",
    stroke: "url(#esNodeEdge)",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -3.5,
    r: 3.4,
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 9 a7.5 6 0 0 1 15 0 z",
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.4 -5.7 A11 11 0 0 1 9.4 -5.7",
    fill: "none",
    stroke: "url(#esTopHiSoft)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(868,326)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 11,
    fill: "url(#esNodeFace)",
    stroke: "url(#esNodeEdge)",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -3.5,
    r: 3.4,
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 9 a7.5 6 0 0 1 15 0 z",
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.4 -5.7 A11 11 0 0 1 9.4 -5.7",
    fill: "none",
    stroke: "url(#esTopHiSoft)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(902,326)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 11,
    fill: "url(#esNodeFace)",
    stroke: "url(#esNodeEdge)",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -3.5,
    r: 3.4,
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 9 a7.5 6 0 0 1 15 0 z",
    fill: "#d7cdf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.4 -5.7 A11 11 0 0 1 9.4 -5.7",
    fill: "none",
    stroke: "url(#esTopHiSoft)",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "eschipsh c1",
    cx: 211,
    cy: 407,
    rx: 40,
    ry: 6,
    fill: "url(#esContact)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "eschipsh c2",
    cx: 357,
    cy: 407,
    rx: 98,
    ry: 6,
    fill: "url(#esContact)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "eschipsh c3",
    cx: 563,
    cy: 407,
    rx: 98,
    ry: 6,
    fill: "url(#esContact)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "eschipsh c4",
    cx: 749,
    cy: 407,
    rx: 78,
    ry: 6,
    fill: "url(#esContact)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#esLiftS)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "eschipbox c1",
    x: 176,
    y: 376,
    width: 70,
    height: 28,
    rx: 14,
    fill: "url(#esChipFace)",
    stroke: "url(#esChipEdge)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "eschipbox c2",
    x: 262,
    y: 376,
    width: 190,
    height: 28,
    rx: 14,
    fill: "url(#esChipFace)",
    stroke: "url(#esChipEdge)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "eschipbox c3",
    x: 468,
    y: 376,
    width: 190,
    height: 28,
    rx: 14,
    fill: "url(#esChipFace)",
    stroke: "url(#esChipEdge)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "eschipbox c4",
    x: 674,
    y: 376,
    width: 150,
    height: 28,
    rx: 14,
    fill: "url(#esChipFace)",
    stroke: "url(#esChipEdge)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "url(#esSceneLight)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "eschipbox c1",
    x: 176,
    y: 376,
    width: 70,
    height: 28,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "eschipbox c2",
    x: 262,
    y: 376,
    width: 190,
    height: 28,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "eschipbox c3",
    x: 468,
    y: 376,
    width: 190,
    height: 28,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "eschipbox c4",
    x: 674,
    y: 376,
    width: 150,
    height: 28,
    rx: 14
  })), /*#__PURE__*/React.createElement("g", {
    className: "dOnly",
    fill: "none",
    stroke: "url(#esTopHiSoft)",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.9 390 A13.1 13.1 0 0 1 190 376.9 L232 376.9 A13.1 13.1 0 0 1 245.1 390"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.9 390 A13.1 13.1 0 0 1 276 376.9 L438 376.9 A13.1 13.1 0 0 1 451.1 390"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.9 390 A13.1 13.1 0 0 1 482 376.9 L644 376.9 A13.1 13.1 0 0 1 657.1 390"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.9 390 A13.1 13.1 0 0 1 688 376.9 L810 376.9 A13.1 13.1 0 0 1 823.1 390"
  })), /*#__PURE__*/React.createElement("g", {
    className: "mOnly",
    fill: "none",
    stroke: "url(#esTopHiSoft)",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9 382 A15.1 15.1 0 0 1 46 366.9 L94 366.9 A15.1 15.1 0 0 1 109.1 382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.9 382 A15.1 15.1 0 0 1 140 366.9 L398 366.9 A15.1 15.1 0 0 1 413.1 382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.9 382 A15.1 15.1 0 0 1 444 366.9 L702 366.9 A15.1 15.1 0 0 1 717.1 382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.9 382 A15.1 15.1 0 0 1 748 366.9 L954 366.9 A15.1 15.1 0 0 1 969.1 382"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "eschip eschiptx c1",
    x: 211,
    y: 395,
    textAnchor: "middle",
    fontSize: 12.5
  }, "SSO"), /*#__PURE__*/React.createElement("text", {
    className: "eschip eschiptx c2",
    x: 357,
    y: 395,
    textAnchor: "middle",
    fontSize: 12.5
  }, "Advanced permissions"), /*#__PURE__*/React.createElement("text", {
    className: "eschip eschiptx c3",
    x: 563,
    y: 395,
    textAnchor: "middle",
    fontSize: 12.5
  }, "Cross-team reporting"), /*#__PURE__*/React.createElement("text", {
    className: "eschip eschiptx c4",
    x: 749,
    y: 395,
    textAnchor: "middle",
    fontSize: 12.5
  }, "Priority support")), /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 436,
    textAnchor: "middle",
    className: "ess",
    fontSize: 14,
    filter: "url(#esTextSh)"
  }, "Many teams \xB7 cross-team rollups \xB7 enterprise controls"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriseScope);
export default __webpack_public_path__ + "static/media/enterprise-scope.552514b80234ae6e497e462f1180171d.svg";
export { ForwardRef as ReactComponent };